export default {
  state: {
    id: undefined,
    sender_name: undefined,
    sender_email: undefined,
    reply_to_email: undefined,
    to_email_filter: undefined,
    html_text: undefined,
    plain_text: undefined,
    subject: undefined,
    remote_permalink: undefined,
    local_permalink: undefined,
    template_id: undefined,
    archived: undefined,
    inactive: undefined,
    subscribers_only: undefined,
    send_at: (new Date().toJSON().slice(0, 19)),
    sent_at: undefined,
    recipient_count: undefined,
    open_count: undefined,
    link_click_count: undefined,
    plain_text_link_click_count: undefined,
    asset_udid: undefined,
    newsletter_type_id: undefined,
    newsletter_type: {},
    puzzles: [],
    puzzle_id: undefined,
    puzzle_link_id: undefined,
    relationships: {},
    newsletter_attachments: [],
    created_at: undefined,
    updated_at: undefined,
    is_queued: undefined,
    status: undefined,
    sent_recipient_count: undefined,
    unsent_recipient_count: undefined,
    loading: false
  }
}



// WEBPACK FOOTER //
// ./src/stores/EmailStore.js